import React, { useRef } from 'react';
import { PropertyDataProps } from '../../utility/types';
import { useGetListSorts } from '../../hooks/api/ListSort/useGetListSorts';
import { useUpdateListSortPropertyJoin } from '../../hooks/api/ListSortPropertyJoin/useUpdateListSortPropertyJoin';
import { ReixMenu } from './dropdowns/ReixMenu';
import { DisabledItemStyling, ItemStyling } from '../../utility/dropdown';
import { Loader } from '../icons/OurIcons';
import { Toast } from 'primereact/toast';
import { useLoginPrompt } from './LoginPromptContext';

type AddPropertyToListProps = {
  property: PropertyDataProps;
};

export const AddPropertyToList = ({ property }: AddPropertyToListProps) => {
  const toast = useRef(null);
  const { isLoggedIn, promptLogin } = useLoginPrompt();

  const { mutateAsync: updateLSPJ } = useUpdateListSortPropertyJoin();

  const { data: listSorts, isLoading } = useGetListSorts();

  let items =
    listSorts && listSorts.length > 0
      ? listSorts?.map((listSort) => ({
          label: listSort.title,
          className: ItemStyling,
          command: async () => {
            try {
              await updateLSPJ({
                listSortId: listSort.id,
                propertyId: property.id,
                status: true,
              });
              toast.current?.show({
                severity: 'success',
                summary: `${property.address.full_address} added to ${listSort.title}`,
              });
            } catch {
              toast.current?.show({
                severity: 'error',
                summary: `Failed to add property to list`,
              });
            }
          },
        }))
      : [{ label: 'No Lists Available', disabled: true }];

  if (isLoading)
    items = [
      {
        label: 'Loading Lists',
        icon: <Loader height={24} width={24} />,
        className: DisabledItemStyling,
        disabled: true,
      },
    ];

  return (
    <>
      <Toast ref={toast} position="bottom-right" />
      <ReixMenu
        title="Add To List"
        items={items}
        onTriggerClick={() => {
          if (!isLoggedIn) {
            promptLogin({ message: 'Sign in to build and save lists.' });
            return false;
          }
        }}
      />
    </>
  );
};
